import React, {useEffect, useState} from "react"
import {useNavigate, useLocation} from "react-router-dom"
import Side from "../../Components/Navbar/PlayersList/Side/Side"
import Loading from "../../Components/Loading/Loading"
import {turkceToEnglish} from "../../Components/PathHelper/PathHelper"
import Pagination from "../../Components/Pagination/Pagination"
import OzelHaberEtiketi from "../../Components/OzelHaberEtiketi/OzelHaberEtiketi"
import OzelHaberImage from "../../Components/OzelHaberEtiketi/OzelHaberImage"
import HaberDefaultImage from "../../img/kıbrıslı-gazetesi-haber-default-img-min.jpg"
import "./Search.css"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export default function Search() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const query = useQuery().get("query") || ""

  const [results, setResults] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  useEffect(() => {
    if (!query) return

    const fetchResults = async () => {
      setLoading(true)
      setError(null)

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/post/?search=${query}&page=${currentPage}&is_published=true`,
          {
            method: "GET",
            headers: {
              Authorization: `Token ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        )

        const data = await response.json()
        setResults(data.results)
        setTotalPages(data.pages)
      } catch (error) {
        console.error("Arama hatası:", error)
        setError("Arama sırasında bir hata oluştu.")
        setResults([])
        navigate("/not-found", {replace: true})
      } finally {
        setLoading(false)
      }
    }

    fetchResults()
  }, [query, currentPage])

  const handleNewsClick = (id, title) => {
    const formattedTitle = turkceToEnglish(title)
    navigate(`/haber/${id}/${formattedTitle}`)
  }

  return (
    <div className="searchScreen">
      <div className="searchScreenContainer">
        <div className="catgeoryAd-articles">
          {loading && <Loading />}
          {error && <p>{error}</p>}
          <h3>
            {" "}
            {`${query}`} için sonuçlar{" "}
            {!loading && results.length === 0 ? " bulunamadı." : " ..."}{" "}
          </h3>
          <div className="catgeoryAd-articles-grid">
            {results.map((article) => {
              const coverImage = article.postimage?.find(
                (img) => img.is_cover_image
              )?.uploaded_image?.image
              const ReporterImg = article.reporter__image

              return (
                <div
                  key={article.id}
                  className="catgeoryAd-article-card"
                  onClick={() => handleNewsClick(article.id, article.header)}
                >
                  <img
                    src={coverImage || HaberDefaultImage}
                    alt={article.header || "Haber Resmi"}
                    className="catgeoryAd-article-image"
                  />
                  {ReporterImg && <OzelHaberImage ReporterImg={ReporterImg} />}
                  {article.postcategory?.find(
                    (categoryItem) => categoryItem.category === 12
                  ) &&
                    !ReporterImg && (
                      <OzelHaberEtiketi showDefaultIfEmpty={true} />
                    )}
                  <h3 className="catgeoryAd-article-title">{article.header}</h3>
                </div>
              )
            })}
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
      <div className="search-details-side-wrapper">
        <Side />
      </div>
    </div>
  )
}
